// Centralized data-testid map for the CDPA site.
export const TID = {
  nav: {
    root: 'site-navbar',
    logo: 'nav-logo',
    home: 'nav-home-link',
    capabilities: 'nav-capabilities-link',
    research: 'nav-research-link',
    partnerships: 'nav-partnerships-link',
    contact: 'nav-contact-link',
    langToggle: 'nav-language-toggle',
    cta: 'nav-cta-button',
    mobileToggle: 'nav-mobile-toggle',
    mobileMenu: 'nav-mobile-menu',
  },
  hero: {
    root: 'hero-section',
    headline: 'hero-headline',
    primaryCta: 'hero-primary-cta',
    secondaryCta: 'hero-secondary-cta',
  },
  who: { root: 'who-we-are-section', cta: 'who-we-are-cta' },
  ballistic: { root: 'ballistic-section', cta: 'ballistic-cta' },
  mobility: { root: 'mobility-section', cta: 'mobility-cta' },
  cbrne: { root: 'cbrne-section', cta: 'cbrne-cta' },
  ammo: { root: 'ammo-section', cta: 'ammo-cta' },
  cuas: { root: 'cuas-section', cta: 'cuas-cta' },
  battery: { root: 'battery-section', cta: 'battery-cta' },
  research: { root: 'research-section', cta: 'research-cta' },
  partnerships: { root: 'partnerships-section', cta: 'partnerships-cta' },
  contact: {
    root: 'contact-section',
    form: 'contact-form',
    name: 'contact-input-name',
    company: 'contact-input-company',
    email: 'contact-input-email',
    phone: 'contact-input-phone',
    message: 'contact-input-message',
    submit: 'contact-submit-button',
    success: 'contact-success-message',
    error: 'contact-error-message',
  },
  footer: { root: 'site-footer' },
};
